import { Component, OnInit } from '@angular/core';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor(private helper: HelperService, private scroll: ScrollToService) { }

  ngOnInit() {
    this.helper.scrollObs.subscribe(scrollTarget => {
      setTimeout(() => {
        this.scroll.scrollTo({target: scrollTarget});
      }, 200);
    });
  }

}
